import { isObject, isArray, isString } from './type';

export const THUMBNAIL_W = 88;
export const THUMBNAIL_H = 88;
export const STORAGE_TYPE_OSS = 'oss';

export function getJSON(target, defaultValue) {
  if (isObject(target) || isArray(target)) return target;

  try {
    return JSON.parse(target);
  } catch {
    return defaultValue;
  }
};

export function getJSONString(target, defaultValue) {
  if (isString(target)) return target;
  
  try {
    return JSON.stringify(target);
  } catch {
    return defaultValue;
  }
};

/**
 * 通过文件地址获取文件名称
 * @param {String} url 文件地址
 * @returns {String} 文件名称
 */
export function getFileName(url) {
  const matchName = url.match(/.*\/(.*)$/) || [];
  return decodeURI(matchName[1]);
}

export function getRandomUid(len = 8) {
  return Math.random()
    .toString(36)
    .slice(-1 * len);
}

/**
 * 深克隆JSON对象
 * @param {JSON} target 需要克隆的JSON对象
 * @returns
 */
export function deepCloneJSON(target) {
  try {
    return JSON.parse(JSON.stringify(target));
  } catch {
    return target;
  }
}
